module.exports = __webpack_public_path__ + "img/bmw-usa_bbf52a92ea5044f8e800607e2a8d33f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/bmw-usa.jpg
// module id = 289
// module chunks = 0